import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export const swipeImageDomainWhitelist = ['www.ikea.com', 'messagecontent.ikea.com'];

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
 */
const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};

const domainGroup = `(${swipeImageDomainWhitelist.map(escapeRegExp).join('|')})`;
export const swipeImageDomainWhitelistPattern = `^https://${domainGroup}/`;

export type SwipeTranslationLinks = Static<typeof SwipeTranslationLinksSchema>;
export const SwipeTranslationLinksSchema = Type.Object({
  startPageImage: Type.String({
    format: 'uri',
    maxLength: 1000,
    pattern: swipeImageDomainWhitelistPattern,
  }),
  winnerPageImage: Type.String({
    format: 'uri',
    maxLength: 1000,
    pattern: swipeImageDomainWhitelistPattern,
  }),
  loserPageImage: Type.String({
    format: 'uri',
    maxLength: 1000,
    pattern: swipeImageDomainWhitelistPattern,
  }),
});

export type SwipeTranslationQuestions = Static<typeof SwipeTranslationQuestionsSchema>;
export const SwipeTranslationQuestionsSchema = Type.Array(
  Type.Object({
    question: Type.String({ minLength: 4, maxLength: 120 }),
    description: Type.String({ minLength: 2, maxLength: 150 }),
    correctAnswerText: Type.Optional(Type.String({ minLength: 2, maxLength: 30 })),
    wrongAnswerText: Type.Optional(Type.String({ minLength: 2, maxLength: 30 })),
    answer: Type.Boolean(),
    image: Type.String({
      format: 'uri',
      maxLength: 500,
      pattern: swipeImageDomainWhitelistPattern,
    }),
  }),
  { maxItems: 100 }
);

export type SwipeTranslation = Static<typeof SwipeTranslationSchema>;
export const SwipeTranslationSchema = Type.Object({
  title: Type.String({
    minLength: 1,
    maxLength: 100,
  }),
  // TODO remove optional when  doing migration script
  body: Type.Optional(
    Type.String({
      minLength: 1,
      maxLength: 1500,
    })
  ),
  questions: SwipeTranslationQuestionsSchema,
  links: Type.Optional(SwipeTranslationLinksSchema),
});
